import { ReactNode } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogProps, Grid, IconButton, Stack, Typography } from '@mui/material';
import { isEmpty } from 'lodash';

import { useWidth } from 'functions/Hooks/useDeviceDetect';

interface StandardDialogProps extends DialogProps {
  title: string;
  handleClose: () => void;
  open: boolean;
  setOpen: (b: boolean) => void;
  children: ReactNode;
  width?: string;
  showCloseButton?: boolean;
}

const StandardDialog = (props: StandardDialogProps) => {
  const currentWidth = useWidth();

  // Title at top of dialog and close button
  const TitleAndClose = () => {
    return (
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography
            variant="h2"
            sx={{
              ...(currentWidth === 'xs' && {
                fontSize: '16px',
                lineHeight: '18px',
              }),
            }}>
            {props.title}
          </Typography>
        </Grid>
        {props.showCloseButton && (
          <Grid item>
            <IconButton
              onClick={() => {
                props.handleClose();
                props.setOpen(false);
              }}>
              <CloseIcon sx={{ ...(currentWidth === 'xs' && { fontSize: '20px' }) }} />
            </IconButton>
          </Grid>
        )}
      </Grid>
    );
  };

  return (
    <Dialog
      {...props}
      onClose={() => props.handleClose()}
      fullWidth={isEmpty(props.width)}
      maxWidth="sm"
      open={props.open}
      PaperProps={{
        sx: {
          borderRadius: '15px',
        },
      }}>
      <Stack direction="column" sx={{ px: 4, py: 2 }}>
        <TitleAndClose />
        {props.children}
      </Stack>
    </Dialog>
  );
};

export default StandardDialog;
